<template>
    <div>
        
        <homeHead></homeHead>
        <homeNav   ></homeNav>
        <div class="pre-box"  v-if="preview==1" >
            <p>当前文章仅用于预览！</p>
        </div>
        <breadcrumb  v-if="$route.query.id" :positionData="positionData" ></breadcrumb>
        <detailsInfo :detailData="detailData" ></detailsInfo>
        <homeFooter></homeFooter>
    </div>
</template>
<script>
import homeHead from '@/components/Public/head.vue'
import homeNav from '@/components/Public/nav.vue'
import breadcrumb from '@/components/Public/breadcrumb.vue'
import detailsInfo from './detailsInfo.vue'
import homeFooter from '@/components/Public/footer.vue'
    export default {
        components:{
            homeHead,
            homeNav,
            breadcrumb,
            detailsInfo,
            homeFooter,
        },
        metaInfo(){
            let currentTitle = '';
            currentTitle = this.detailData.title?this.detailData.title:this.title;
            return {
                title: currentTitle,
                meta:[{
                     name: this.detailData&& this.detailData.title? this.detailData.title:this.$store.state.webInfo.key_words,
                     content:this.detailData&&this.detailData.description?this.detailData.description:this.$store.state.webInfo.describe
                 }],
                 link: [{                
                    rel: 'asstes',
                    href: this.$url.webUrl
                }]
            } 
        },
        data(){
            return {
                title:'',
                id:null, //一级导航
                second_navId:null,//二级导航
                positionData:[],//当前位置  
                detailData:{},
                newsId:null,// 
                preview:'',
            }
        },
        methods:{
                    
        },
        created(){

            this.newsId  = Number(this.$route.query.newsId)  
            this.id      = Number(this.$route.query.id) 
            this.preview = this.$route.query.preview

            if(this.$route.query.id ){
                this.$db.get(this.$url.channel.childList+'?id='+this.id).then(res=>{
                    this.positionData = res.data
                    this.positionData.forEach(element => {
                        if(element.pid==0){
                            this.title = element.title
                        }
                    });
                }).catch(err => {
            console.log(err);
          });
            }

            this.$db.get(this.$url.document.url+"/"+this.newsId).then(res=>{
                this.detailData = res.data
            }).catch(err => {
            console.log(err);
          });
        }
    }
</script>
<style lang="less" scoped>
    .pre-box{
        height: 50px;
        margin: 0 auto;
        width: 1200px;
        background-color: bisque;
        >p{
            text-indent:15px;
            color: #ab0f13;
            line-height: 50px;
            font-size: r(24);
        }
    }
    .detailsInfo{
        margin-top: 84px;
    }
</style>


// WEBPACK FOOTER //
// src/components/dynamics/details.vue